module.exports = __webpack_public_path__ + "img/weal5.dae77c84.png";